import { Form } from "antd";
import { useMemo } from "react";

import type { DatePickerAttributes, FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { DatePickerInput } from "./DatePicker";

export const DatePickerField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const attributes = useMemo(() => ({ ...field.attributes }) as DatePickerAttributes, [field.attributes]);

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <DatePickerInput key={field.name} name={field.name} readOnly={readOnly} type={attributes.type} format={attributes.format} />
        </Form.Item>
    );
};
